import 'css-chunksrc/client/pages/documentsPage/documentsPage/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_2pnn4_1",
  "main": "_main_2pnn4_9",
  "title": "_title_2pnn4_13",
  "subTitle": "_subTitle_2pnn4_20",
  "menu": "_menu_2pnn4_27",
  "menuItem": "_menuItem_2pnn4_38",
  "menuText": "_menuText_2pnn4_53",
  "iconBox": "_iconBox_2pnn4_59",
  "icon": "_icon_2pnn4_59",
  "fileIcon": "_fileIcon_2pnn4_71",
  "lockIcon": "_lockIcon_2pnn4_76",
  "block": "_block_2pnn4_80"
};